import React, { PureComponent } from 'react';

export default class UserColumnCell extends PureComponent {
  render(){
    return <div  title={this.props.userName} style={{padding: '6px'}}>
        <div className="text-align-center truncate">
          <b>{this.props.userName}</b>
        </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/userPlanPermissionTable/userColumnCell.js